import { fetchPicture, fetchUser, updateProfile, verifyUpdatedPhone } from '@mobile-dev/platform/common/redux/actions/AmplifyUserAction'
import Tooltip from '@mui/material/Tooltip'
import { Auth, Storage } from 'aws-amplify'
import { isEmpty } from 'lodash'
import React, { useEffect, useRef, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import avatarlogo from '../../assets/images/avatar.svg'
import leftarrow from '../../assets/images/left-arrow.svg'
import { AppConstatnt } from '../../Utils/AppConstant'
import { formatPhone, getApplicationFlow, getTheme, showAlert, toastOptions, TranslateAccent } from '../../Utils/Utility'
import { emailPattern, signupValidation, validStringPattern } from '../../Utils/ValidationUtils'
import Loader from '../Common/Loader'
import LoaderSubmitButton from '../Common/LoaderSubmitButton'
import MobileInput from '../Common/MobileInput/MobileInput'
import VerifyOTP from './VerifyOtp';
import { getCarriersAction } from '@mobile-dev/platform/common/redux/actions/GetCarriers';
import { addCarrierAction } from '@mobile-dev/platform/common/redux/actions/AddCarrierAction';
import CreatableSelectCommon from '../Common/CreatableSelect/CreatableSelect'
import { injectIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { clearError } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import ErrornDialog from "../Common/ErrorDialog/ErrorDialog";

function EditProfile({ intl }) {
    
    const flow = getApplicationFlow() === 'Carrier' ? 'Carrier' : 'Driver';
    const [previewImage, setPreviewImage] = useState('');
    const dispatch = useDispatch();
    const auth = useSelector(state => state.amplifyUser);
    const userData = auth.user.attributes;
    const history = useHistory();
    const getCarriers = useSelector(state => state.getcarrier);
    const addCarrier = useSelector(state => state.addCarrier)
    const [oldPhone, setOldPhone] = useState(null);
    const [emailerrormessage, setEmailerrormessage] = useState(null)
    const { handleSubmit, register, formState: { errors } } = useForm();
    const [carrierOptions, setCarrierOptions] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [dispatchPhone, setDispatchPhone] = useState("");
    const ref = useRef();

    const initialState = {
        firstName: userData?.given_name || '',
        lastName: userData?.family_name || '',
        phone: userData?.phone_number || '',
        email: userData?.email || '',
        carrier: userData['custom:carrier'] || '',
        dispatchNumber: userData['custom:carrierPhone'] || ''
    }
    const [carrierNameInput, setCarrierNameInput] = useState({ 'label': initialState.carrier, value: initialState.carrier });

    const [profileInfo, setProfileInfo] = useState(initialState)
    const [picture, setPicture] = useState(null);
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [isPhoneChanged, setChangedPhone] = useState(false);
    const [otp, setOtp] = useState(null);
    const [creatableTheme, setCreatableTheme] = useState(getTheme())
    const toastId = useRef(null);
    const themeStyle = getTheme() === AppConstatnt.theme.DARK ? 'light' : '';
    const { formatMessage } = intl;

    useEffect(() => {
        dispatch(clearError());
    }, []);

    useEffect(() => {
        setCreatableTheme(getTheme())
    },[getTheme()])

    useEffect(() => {
        if (auth.profilePic) {
            setPicture(auth.profilePic);
            setPreviewImage(null);
        }
    }, [auth.profilePic]);

    useEffect(() => {
        if (getCarriers?.carriers) {
            customizeGetCarriers()
        }
    }, [getCarriers.carriers])

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        const pic = URL.createObjectURL(file);
        setPreviewImage(pic);
        setPicture(null);
        uploadPic(file);
    }

    const onSubmit = data => {
        data.carrier = ''
        if (flow === 'Driver' && formatPhone(profileInfo.phone) !== userData.phone_number) {
            setChangedPhone(true);
            setOldPhone(userData.phone_number);
        } else if (flow === 'Carrier') {
            setProfileInfo({ ...profileInfo, phone: '' });
            data.carrier = data.carrierName = carrierNameInput?.label || '';
        }
        data.dispatchNumber = formatPhone(profileInfo.dispatchNumber);
        data.phone = profileInfo.phone;
        data.firstName = TranslateAccent(data.firstName);
        data.lastName = TranslateAccent(data.lastName);
        if (data.email === data.reenteremail) {
            delete data.reenteremail
            dispatch(updateProfile(data, toast));
            history.push({ pathname: '/profile' });
        }
        else {
            showAlert(toast.TYPE.WARNING, "Email does not match")
        }
        

    }

    const handlePhone = (phone) => {
        if (flow === 'Driver') {
            setProfileInfo({ ...profileInfo, phone: phone });
        } else if (flow === 'Carrier') {
            setProfileInfo({ ...profileInfo, dispatchNumber: phone })
        }
    }

    const handleVerifyOtp = () => {
        dispatch(verifyUpdatedPhone(oldPhone, otp, toast));
        dispatch(fetchUser());
        setChangedPhone(false);
        setOtp(null);
    }

    const handleOtp = (ot) => {
        setOtp(ot);
    }

    if (!userData) {
        return <Loader />
    }


    const uploadPic = async (pic) => {
        try {
            setUploadInProgress(true);
            const result = Storage.put(`profilePic.jpg`, pic, {
                progressCallback(progress) {
                    let percent = (progress.loaded / progress.total) * 100;
                    percent = Math.round(percent);

                },
                contentType: 'image/png',
                level: 'private'
            });

            const res = await toast.promise(result, {
                pending: 'Uploading profile picture....',
                success: 'Profile Picture Upload Success',
                error: 'Upload failed, please check errors'
            });


            setUploadInProgress(false);
            const loggeduser = await Auth.currentAuthenticatedUser();
            await Auth.updateUserAttributes(loggeduser, { 'custom:isProfilePicUploaded': 'true' });
            dispatch(fetchPicture(auth.user));
        } catch (error) {

        }
    }

    const { firstName, lastName, email, phone, carrier, dispatchNumber } = profileInfo;


    if (!isEmpty(errors)) {
        Object.keys(errors).map(e => {
            signupValidation.filter(s => s.name === e).forEach(v => {
                if (!toast.isActive(toastId.current)) {
                    toastOptions.autoClose = true;
                    toastOptions.type = 'warning';
                    toastId.current = toast(v.message, toastOptions);
                }
            });
        });
    }

    const carrierNameHandler = (e) => {
        if (e) {
            setCarrierNameInput(e);
            if (e.length === 2) {
                setisLoading(true);
                dispatch(getCarriersAction(e));
            }
        }
    }


    const customizeGetCarriers = () => {
        if (getCarriers.carriers.length) {
            const customizedArray = getCarriers?.carriers.map(el => {
                return {
                    label: el.carrier_name,
                    value: el.carrier_id,
                    carrier_id: el.carrier_id,
                    carrier_name: el.carrier_name,
                }
            })
            setCarrierOptions(customizedArray);
            setisLoading(false);
        }
    }
    const createHandler = (e) => {
        setCarrierNameInput(e)
        if (e?.__isNew__) {
            dispatch(addCarrierAction({
                name: e.label,
                contact_phone: dispatchPhone
            }))
        }
    }

    const oProps = {
        creatableTheme,
        carrierNameInput, setCarrierNameInput,
        carrierOptions, setCarrierOptions,
        isLoading, setisLoading,
        ref,
        carrierNameHandler, createHandler,
        placeholderText: formatMessage({id: "app.carrier_name_placeholder"}),
        defaultValue: [{ 'label': initialState.carrier, value: initialState.carrier }],
        name: formatMessage({id: "app.carrier_name"}),
        formatCreateLabelText: () => `${formatMessage({id: "app.carrier_name_formatCreateLabelText"})} "${carrierNameInput}"`,
        loadingMessageText: () => formatMessage({id: "app.carrier_name_loadingMessageText"})
    }

    return (
        <div className="content-page">
            <div className="content">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="contest_input_block">
                        <div className="top_header_bar">
                            <div className="row">
                                <div className="col-sm col-xl-4 d-flex align-items-center p-0">
                                    <Link to={`/profile`} className="text-dark" style={{ marginRight: "15px" }}>
                                        <img src={leftarrow} className="bakc-arrow" />
                                    </Link>
                                    <h3 className="m-0 h3-heading" title="Edit Profile">{formatMessage({ id: "app.edit_profile" })}</h3>
                                </div>
                                <div className="col-sm-6 col-xl-8 d-flex align-items-center justify-content-end p-0">
                                    <LoaderSubmitButton
                                        className='btn btn-chartreuse justify-content-center'
                                        name={formatMessage({ id: "app.save" })}
                                        loading={auth.loading}
                                        icon='fal fa-copy fa-fw'
                                        style={{ minWidth: "158px" }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="container_block" style={{ padding: "40px" }}>

                            <div className="row met-profile">
                                <div className="col-lg-4 align-self-center mb-3 mb-lg-0">
                                    <div className="met-profile-main">
                                        <div className="met-profile-main-pic">
                                            <img src={picture || previewImage || avatarlogo} alt={userData.given_name} className="rounded-circle " />
                                            <div className="image-upload">
                                                <span className="met-profile_main-pic-change">
                                                    <label htmlFor="file-input">
                                                        {uploadInProgress ? <Spinner animation="grow" variant="primary" />
                                                            : <i className="fal fa-camera" style={{ cursor: 'pointer' }}></i>
                                                        }
                                                    </label>
                                                </span>
                                                <input type="file" id="file-input" accept="image/*" onChange={handleImageChange} style={{ display: 'none' }} />
                                            </div>

                                        </div>

                                    </div>
                                </div>


                                {!isPhoneChanged && <div className="col-lg-4 ms-auto">

                                    <div className="form-group">
                                        <label htmlFor="name" className="mb-2 required">
                                            <i className="fal fa-user fa-fw text-secondary font-22 align-middle"></i>{formatMessage({ id: "app.first_name" })}</label>
                                        <Tooltip title={formatMessage({ id: "app.first_name_tooltip" })} enterTouchDelay={0} arrow>
                                            <input type="text" name="firstName" className="form-control" placeholder={formatMessage({ id: "app.first_name_placeholder" })}
                                                data-tip data-for='firstName'
                                                defaultValue={firstName}
                                                {...register("firstName", { required: true, pattern: validStringPattern })} />
                                        </Tooltip>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name" className="mb-2 required">
                                            <i className="fal fa-user fa-fw text-secondary font-22 align-middle"></i> {formatMessage({ id: "app.last_name" })}</label>
                                        <Tooltip title={formatMessage({ id: "app.last_name_tooltip" })}
                                            enterTouchDelay={0} arrow>
                                            <input type="text" name="lastName" className="form-control" placeholder={formatMessage({ id: "app.last_name_placeholder" })}
                                                defaultValue={lastName}
                                                {...register("lastName", { required: true, pattern: validStringPattern })}
                                            />
                                        </Tooltip>
                                    </div>
                                    {
                                        flow === 'Carrier' &&
                                        <div className="form-group">
                                            <label htmlFor="carrierName" className="mb-2 required">
                                                <i className="fal fa-user fa-fw text-secondary font-22 align-middle"></i> {formatMessage({ id: "app.carrier_name"})}
                                            </label>
                                            <Tooltip title={formatMessage({id: "app.carrier_name_tooltip"})} enterTouchDelay={0} arrow placement="top">
                                                <div>
                                                    <CreatableSelectCommon {...oProps} />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    }
                                </div>
                                }
                                {!isPhoneChanged && <div className="col-lg-4 ms-auto">
                                    {/* <div className="form-group">
                                        <label htmlFor="mobileNo" className="mb-2 required">
                                            <i className="fal fa-phone-alt fa-fw text-secondary font-22 align-middle"></i> {formatMessage({ id: "app.mobile_number" })}</label>
                                        <MobileInput
                                            phone={flow === 'Driver' ? phone : dispatchNumber}
                                            handlePhone={handlePhone}
                                        />
                                    </div> */}
                                    <div className="form-group">
                                        <label htmlFor="email" className="mb-2 required">
                                            <i className="fal fa-envelope fa-fw text-secondary font-22 align-middle"></i> {formatMessage({ id: "app.email" })}</label>
                                        <input type="text" name="email" className="form-control"
                                            placeholder="Enter Email" defaultValue={email}
                                            {...register("email", { required: true, pattern: emailPattern })}
                                        />
                                        {emailerrormessage && <div className="error mb-2" style={{ color: "#f97474" }}>{emailerrormessage}</div>}

                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="reenteremail" className="mb-2 required">
                                            <i className="fal fa-envelope fa-fw text-secondary font-22 align-middle"></i> {formatMessage({ id: "app.re-enter_email" })}</label>
                                        <input type="email" className="form-control" placeholder="Re-Enter Email" defaultValue={email}
                                            {...register("reenteremail", { required: true, pattern: emailPattern })}
                                        />
                                    </div>
                                </div>
                                }
                                {isPhoneChanged &&
                                    <VerifyOTP
                                        handleVerifyOtp={handleVerifyOtp}
                                        loading={auth.loading}
                                        open
                                        handleOtp={handleOtp}
                                        otp={otp}
                                    />
                                }
                            </div>

                        </div>
                    </div>
                </form>
                {getCarriers?.error || addCarrier?.error  && <ErrornDialog open />}
            </div>

        </div>
    )

}

export default injectIntl(EditProfile);
